import { render, staticRenderFns } from "./TournamentEvents.vue?vue&type=template&id=6e6f229e&"
import script from "./TournamentEvents.vue?vue&type=script&lang=js&"
export * from "./TournamentEvents.vue?vue&type=script&lang=js&"
import style0 from "./TournamentEvents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TournamentEvents.vue"
export default component.exports